/**
 * WordPress Dependencies.
 */
import domReady from '@wordpress/dom-ready';
import { registerPlugin } from '@wordpress/plugins';
import { TextControl, SelectControl } from '@wordpress/components';
import { PluginDocumentSettingPanel } from '@wordpress/edit-post';

import { __ } from '@wordpress/i18n';
import { useDispatch, useSelect } from '@wordpress/data';

import { capitalize } from 'lodash';

domReady( () => {
	registerPlugin( 'coingate-chain-id-picker', {
		render: () => {
			const metaKey = 'coingate-chain-id';

			const currentChainId = useSelect( ( select ) => {
				const postMeta = select( 'core/editor' ).getEditedPostAttribute(
					'meta'
				);
				return metaKey in postMeta ? postMeta[ metaKey ] : '';
			} );
			const { editPost } = useDispatch( 'core/editor' );

			const handleChange = ( newChain ) => {
				editPost( {
					meta: {
						[ metaKey ]: newChain,
					},
				} );
			};

			const chains = [
				'ethereum',
				'polygon',
				'arbitrum',
				'optimism',
				'ropsten',
				'rinkeby',
				'kovan',
				'goerli',
				'sepolia',
			].map( ( chain ) => {
				return {
					label: capitalize( chain ),
					value: chain,
				};
			} );

			return (
				<PluginDocumentSettingPanel
					icon={ () => null }
					title={ __( 'Chain Id', 'web3-token-gate' ) }
					name="web3tokengate-chain-id-panel"
					className="web3tokengate-chain-id-panel"
				>
					<SelectControl
						label={ __( 'Chain', 'web3-token-gate' ) }
						onChange={ handleChange }
						options={ chains }
						value={ currentChainId }
						help={ __(
							'Select a block chain.',
							'web3-token-gate'
						) }
					/>
				</PluginDocumentSettingPanel>
			);
		},
	} );
} );
